export enum PushboxStatesEnum {
  Process = 'auth.alcmeon.pushbox.process',
  Pushbox = 'auth.alcmeon.pushbox',
  Tasks = 'auth.alcmeon.pushbox.tasks',
}
